import React from 'react';
import { IonCol, IonGrid, IonRow, IonText } from '@ionic/react';
import { getSummaryFields } from './utils';

export const GridTable = ({ rows, cols }) => {
  if (!rows || rows.length === 0) {
    return <IonText color="medium">There are no records to display</IonText>;
  }
  return (
    <div style={{ overflowX: 'auto' }}>
      <div className="reports-table-outer">
        <IonGrid className="reports-grid" style={{ width: 'max-content', '--reports-col-count': cols.length }}>
          <IonRow className="reports-header">
            {cols.map((col) => (
              <IonCol key={col} className='reports-cell'>
                <b>{col}</b>
              </IonCol>
            ))}
          </IonRow>
          {rows.map((row, idx) => (
            <IonRow key={idx} className="reports-row">
              {cols.map((col) => (
                <IonCol key={col} className='reports-cell'>
                  <IonText>{row[col]}</IonText>
                </IonCol>
              ))}
            </IonRow>
          ))}
        </IonGrid>
      </div>
    </div>
  );
};

// getSummaryFields moved to utils.js

export const MobileCards = ({ rows, cols, sectionKey }) => {
  if (!rows || rows.length === 0) {
    return <IonText color="medium">There are no records to display</IonText>;
  }
  const summary = getSummaryFields(cols);
  const [expanded, setExpanded] = React.useState({});
  const toggle = (key) => setExpanded((prev) => ({ ...prev, [key]: !prev[key] }));

  return (
    <div className="reports-cards">
      {rows.map((row, idx) => {
        const cardKey = `${sectionKey}-${idx}`;
        const isOpen = !!expanded[cardKey];
        const titleField = summary[0];
        const titleValue = row[titleField];
        const isLast = idx === rows.length - 1;
        const titleText = (sectionKey === 'tenants' && isLast) ? 'Total' : (titleValue || `Row ${idx + 1}`);
        const excludeTitleChip = Boolean(titleValue) || (sectionKey === 'tenants' && isLast);
        const hideTenantTotals = sectionKey === 'tenants' && isLast;
        const isTenantTotalHiddenField = (field) => {
          const key = String(field).toUpperCase();
          return key === 'HSE NO' || key === 'NAME' || key === 'PHONE NO';
        };
        const chipFields = summary.filter((field, i) => {
          if (i === 0 && excludeTitleChip) return false;
          if (hideTenantTotals && isTenantTotalHiddenField(field)) return false;
          return true;
        });
        const detailFields = cols
          .filter(c => !summary.includes(c))
          .filter((field) => !(hideTenantTotals && isTenantTotalHiddenField(field)));
        return (
          <div key={cardKey} className="reports-mobile-card">
            <div className="reports-mobile-card-header" onClick={() => toggle(cardKey)}>
              <div className="reports-mobile-card-title">{titleText}</div>
              <div className="reports-mobile-card-toggle">{isOpen ? '▲' : '▼'}</div>
            </div>
            <div className="reports-mobile-card-summary">
              {chipFields.map((field) => (
                <div key={field} className="reports-mobile-chip">
                  <span className="reports-mobile-chip-label">{field}</span>
                  <span className="reports-mobile-chip-value">{String(row[field] ?? '')}</span>
                </div>
              ))}
            </div>
            {isOpen && (
              <div className="reports-mobile-card-details">
                {detailFields.map((field) => (
                  <div key={field} className="reports-mobile-detail-row">
                    <div className="reports-mobile-detail-label">{field}</div>
                    <div className="reports-mobile-detail-value">{String(row[field] ?? '')}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export { isSmallScreen } from './utils';


